import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpService} from '../../../../../../../core';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder} from '@angular/forms';


@Component({
  selector: 'app-buyer-choice-edit',
  templateUrl: './buyer-choice-create.component.html',
  styleUrls: ['./buyer-choice-create.component.scss']
})

export class BuyerChoiceCreateComponent implements OnInit {
  submitted: any;
  buyerChoiceForm: any;

  constructor(private dialogRef: MatDialogRef<any>,
              private httpService: HttpService,
              private toastrService: ToastrService,
              private fb: FormBuilder,
              private cdr: ChangeDetectorRef,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.buyerChoiceForm = this.fb.group({
      colorScheme: [''],
      mobileBenchOption: [''],
      dishAccessory: ['']
    });

  }

  ngOnInit(): void {
  }

  get f() {
    return this.buyerChoiceForm.controls;
  }

  submit() {
    if (this.buyerChoiceForm.invalid) {
      return;
    }

    const fd = new FormData();
    fd.append('propertyId', this.data.property.id);
    fd.append('colorScheme', this.buyerChoiceForm.get('colorScheme').value);
    fd.append('mobileBenchOption', this.buyerChoiceForm.get('mobileBenchOption').value);
    fd.append('dishAccessory', this.buyerChoiceForm.get('dishAccessory').value);
    this.httpService.createBuyerChoice(fd).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.toastrService.success('Buyer choice has been created');
        this.dialogRef.close({code: 1, buyerChoice: res.data});
      } else {
        this.toastrService.error('Failed to create buyer choice');
      }
    });
  }

}
